import { render, staticRenderFns } from "./after-sales-extension.vue?vue&type=template&id=596686b4&scoped=true&"
import script from "./after-sales-extension.vue?vue&type=script&lang=js&"
export * from "./after-sales-extension.vue?vue&type=script&lang=js&"
import style0 from "./after-sales-extension.vue?vue&type=style&index=0&id=596686b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596686b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('596686b4')) {
      api.createRecord('596686b4', component.options)
    } else {
      api.reload('596686b4', component.options)
    }
    module.hot.accept("./after-sales-extension.vue?vue&type=template&id=596686b4&scoped=true&", function () {
      api.rerender('596686b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/modules/after-sales-extension.vue"
export default component.exports